import HCheckArray from "@rf-helper/check-have-value";
import { IPropertyForm } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";
const prepareCaracteristicToServer = (body: IPropertyForm) => {
  return {
    bedrooms: getValue(body.bedrooms_property),
    bathrooms: getValue(body.bathrooms_property),
    half_bathrooms: getValue(body.half_bathrooms_property),
    parking_spots: getValue(body.parking_spots_property),
    pumps: getValue(body.pumps_property),
    floor_level: getValue(body.level_floor_property),
    floors_total: getValue(body.total_floor_property)
  };
};

export default prepareCaracteristicToServer;

const getValue = (a: number[]) => {
  return (HCheckArray(a) && a[0]) || 0;
};
